import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=4c9a14b8&scoped=true&"
import script from "./SelectLang.vue?vue&type=script&lang=js&"
export * from "./SelectLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a14b8",
  null
  
)

export default component.exports